import { useState } from 'react';
import styled from 'styled-components';

import AiBannerIcon from '@/components/atom/icon/AiBannerIcon';
import BottomSheet from '@/components/molecules/BottomSheet';
import useCustomRouter from '@/hooks/useCustomRouter';
import useToast from '@/hooks/useToast';
import { coreLogger } from '@/utils/logger';

const AiNoticeBanner = () => {
  const { pageName } = useCustomRouter();
  const { showToast } = useToast();
  const [isOpened, setIsOpened] = useState<boolean>(false);
  const handleAiBannerClick = () => {
    coreLogger({
      eventName: `click_banner_ai_open`,
      pageName: pageName,
    });
    setIsOpened(true);
  };
  const handleBottomButtonClick = () => {
    coreLogger({
      eventName: `click_notice_ai_open_in_popup`,
      pageName: pageName,
    });
    setIsOpened(false);
    showToast({ message: 'AI 문진 서비스가 오픈하면 알려드릴게요.' });
  };

  return (
    <Wrapper>
      <BannerContainer onClick={handleAiBannerClick}>
        <BannerContentsContainer>
          <BannerTitle>지금 이 증상, 뭐지?</BannerTitle>
          <BannerSubTitle>클릭만으로 질병을 찾아드려요</BannerSubTitle>
        </BannerContentsContainer>
        <div>
          <AiBannerImageContainer />
        </div>
      </BannerContainer>
      <BottomSheet
        isOpened={isOpened}
        onClickOverlay={() => setIsOpened(false)}
      >
        <BottomSheetContainer>
          <AiBannerIcon />
          <BottomSheetContentsTitle>
            증상을 클릭하면 질병을 찾아주는
            <br />
            AI 문진 서비스가 곧 오픈해요
          </BottomSheetContentsTitle>
          <BottomSheetContentsSubTitle>
            <em>1,800개의 데이터</em>로 세밀하게 분석해 드려요
          </BottomSheetContentsSubTitle>
          <BottomSheetButton onClick={handleBottomButtonClick}>
            오픈 알림 받기
          </BottomSheetButton>
        </BottomSheetContainer>
      </BottomSheet>
    </Wrapper>
  );
};

export default AiNoticeBanner;

const Wrapper = styled.div`
  padding: 0px 24px;
  margin: 24px 0 20px;
  width: 100%;
`;

const BannerContainer = styled.button`
  width: 100%;
  background: ${({ theme }) => theme.color.gray30};
  padding: 0px 16px 0px 24px;
  height: 96px;
  border-radius: 18px;
  display: flex;
  text-align: left;
  border: none;
  justify-content: space-between;
`;

const BannerContentsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const BannerTitle = styled.p`
  ${({ theme }) => theme.typography.UI17B};
  color: ${({ theme }) => theme.color.gray700};
`;

const BannerSubTitle = styled.p`
  ${({ theme }) => theme.typography.UI15R};
  color: ${({ theme }) => theme.color.gray400};
`;

const AiBannerImageContainer = styled.div`
  background: url('images/aiBannerImage.png');
  background-size: cover;
  width: 96px;
  height: 96px;
`;

const BottomSheetContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 40px 24px 24px;
`;

const BottomSheetContentsTitle = styled.p`
  margin-top: 20px;
  margin-bottom: 8px;
  ${({ theme }) => theme.typography.UI20SB};
  color: ${({ theme }) => theme.color.gray700};
  text-align: center;
`;

const BottomSheetContentsSubTitle = styled.p`
  margin: 0;
  ${({ theme }) => theme.typography.UI15M};
  color: ${({ theme }) => theme.color.gray400};
  text-align: center;
  & > em {
    color: ${({ theme }) => theme.color.primary700};
    font-style: normal;
  }
`;

const BottomSheetButton = styled.button`
  border: none;
  ${({ theme }) => theme.typography.UI18SB};
  background: ${({ theme }) => theme.color.primary500};
  color: ${({ theme }) => theme.color.white};
  border-radius: 12px;
  width: 100%;
  height: 60px;
  margin-top: 40px;
`;
